import { render, staticRenderFns } from "./ConsultaParecer.vue?vue&type=template&id=a7e59906"
import script from "./ConsultaParecer.vue?vue&type=script&lang=ts&setup=true"
export * from "./ConsultaParecer.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports